import { compareAsc, parseISO } from 'date-fns';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { projectActions } from 'store/project/project.slice';
import { timesheetServices } from 'store/time-sheet/time-sheet.services';
import { timesheetActions } from 'store/time-sheet/time-sheet.slice';

export const useTimesheetInfo = (employeeId, filtersByStatus = true) => {
  const dispatch = useDispatch();
  const week = useSelector((state) => state.timesheet.days);
  const timeSheetRenderDelay=useSelector((state)=>state.appConfiguration?.timeSheetRenderDelay)
  const [timesheet, setTimesheetInfo] = useState(null);
  const [finalWeekId, setFinalWeekId] = useState(null);
  const [loadings,Setloading]=useState(true)
  useEffect(() => {
    dispatch(projectActions.getProjectsForTimesheet(filtersByStatus));
  }, []);

 
  useEffect(() => {
    if (!week?.weekId) return;
    const timer = setTimeout(() => {
      setFinalWeekId(week.weekId);
    }, timeSheetRenderDelay); 
    return () => clearTimeout(timer); 
  }, [week?.weekId]);

  useEffect(() => {
    if (!employeeId || !finalWeekId) return;

    dispatch(timesheetActions.setLoading(true));
    
    (async () => {
      try {
        const res = await timesheetServices.getTimeSheetByUserAndWeek({
          employeeId: employeeId,
          weekId: finalWeekId
        });

        const timeSheet = res.data.data;
        if (timeSheet && !_.isEmpty(timeSheet) && !Array.isArray(timeSheet)) {
          timeSheet.timeSheetEntryPerActivities = timeSheet.timeSheetEntryPerActivities.map((e) => ({
            ...e,
            projectId: e.project.id,
            activityCascader: [e.subproject.id, e.activity.id],
            activityId: e.activityId || e.activity.id,
            dayActivityLinks: week.days
              ?.reduce((accumulator, fwd) => {
                if (!accumulator.some((da) => da.date === fwd.theDate)) {
                  return [...accumulator, { date: fwd.theDate, manHours: 0 }];
                }
                return accumulator;
              }, e.dayActivityLinks)
              .sort((a, b) => compareAsc(parseISO(a.date), parseISO(b.date)))
          }));
          setTimesheetInfo(timeSheet);
        } else {
          setTimesheetInfo(null);
        }
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(timesheetActions.setLoading(false));
        Setloading(false);
      }
    })();
  }, [finalWeekId, employeeId]);

  return timesheet;
};
